import React from 'react'
import yn from 'yn'
import moment from 'moment/moment'
import formatPrice from '../../../utilities/currency/formatPrice'

const BkFlowRoomCardNightlyRates = props => {
	const {
		configData,
		activeCurrencyData,
		roomRateData,
		rateCurrencyCode,
		rateCurrencySymbol
	} = props

	const hotelLabels = configData.hotel.labels[0]

	let nightlyRatesEntries = []

	for (let NightlyRateKey in roomRateData.viewExtensions.nightlyRates) {
		const nightlyRates = roomRateData.viewExtensions.nightlyRates[NightlyRateKey]

		let nightlyRatePrice = nightlyRates.amountBeforeTax
		let nightlyRatePriceBeforeDiscount = null

		if (nightlyRates.discountBeforeTax) {
			nightlyRatePriceBeforeDiscount = nightlyRates.discountBeforeTax + nightlyRates.amountBeforeTax
		}

		// Calculated exchange format for daily price
		if (
			yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
			activeCurrencyData &&
			activeCurrencyData.exchangeRate
		) {
			nightlyRatePrice = nightlyRates.amountBeforeTax * activeCurrencyData.exchangeRate

			// Calculated exchange format for discounted night rates
			if (nightlyRates.discountBeforeTax) {
				if (
					yn(process.env.REACT_APP_COMPONENT_ENABLE_FOREX) &&
					activeCurrencyData &&
					activeCurrencyData.exchangeRate
				) {
					nightlyRatePriceBeforeDiscount = nightlyRates.discountBeforeTax + nightlyRates.amountBeforeTax * activeCurrencyData.exchangeRate
				} else {
					nightlyRatePriceBeforeDiscount = nightlyRates.discountBeforeTax + nightlyRates.amountBeforeTax
				}
			}
		}

		nightlyRatesEntries.push(
			<div
				className="bk-flow-room__price-details-accordion-row"
				key={ NightlyRateKey }
			>
				{ nightlyRates.date && <p className="label">{ moment(nightlyRates.date, 'YYYY-MM-DD').format('MMMM D, YYYY') }&nbsp;</p> }

				{ nightlyRatePrice ?
					<p className="value">
						{ nightlyRatePriceBeforeDiscount &&
							<span className="pre-discount u-txt-strike">
								{ rateCurrencySymbol && rateCurrencySymbol }{ formatPrice(nightlyRatePriceBeforeDiscount, 2) }&nbsp;
							</span>
						}

						<span className="rate u-font-bold">{ rateCurrencySymbol }{ formatPrice(nightlyRatePrice, 2) }</span>
						{ rateCurrencyCode && ' ' + rateCurrencyCode }
					</p>
				:
					<p className="value">
						<span className="rate u-font-bold">{ rateCurrencySymbol }0.00</span>
						{ rateCurrencyCode && rateCurrencyCode }
					</p>
				}
			</div>
		)
	}

	return (
		<div className="bk-flow-room__price-details-accordion-data-group">
			<h6>{ hotelLabels && hotelLabels.dailyRateSummary ? hotelLabels.dailyRateSummary : 'Daily Rate Summary'}</h6>
			<div className="bk-flow-room__price-details-accordion-data-content">
				{ nightlyRatesEntries }
			</div>
		</div>
	)
}

export default BkFlowRoomCardNightlyRates


// WEBPACK FOOTER //
// ./src/components/room/elements/BkFlowRoomCardNightlyRates.js